<template>
  <div class="column-chart" v-loading="loading" :style="{ height: (options.height + 25) + 'px' }">

    <div class="title">
      {{ title.toUpperCase() }}
    </div>

    <GChart
      :settings="({ packages: ['bar'] })"
      :options="options" :data="data"
      @ready="onChartReady"
      type="ColumnChart"
    ></GChart>

  </div>
</template>

<script>
  import { GChart } from 'vue-google-charts'
  import { bus } from '../Bus'

  export default {
    name: 'ColumnChart',
    components: {GChart},
    props: ['options', 'chartData', 'chartColumns', 'title', 'isAdmin'],
    data () {
      return {
        chartsLib: null,
        data: [],
        chart: null,
        loading: true
      }
    },
    watch: {
      chartData: function () {
        if (this.chartsLib !== null) {
          this.loading = true
          this.drawChart()
        }
      },
      isAdmin: function () {
        if (this.chartsLib !== null) {
          this.loading = true
          this.drawChart()
        }
      },
      title: function () {
        if (this.chartsLib !== null) {
          this.loading = true
          setTimeout(() => {
            this.drawChart()
          }, 500)
        }
      }
    },
    mounted: function () {
      bus.$on('Portale_DrawChart', () => {
        this.$nextTick(() => {
          this.drawChart()
        })
      })
    },
    methods: {
      drawChart: function () {
        let data = new this.chartsLib.visualization.DataTable()

        this.chartColumns.forEach((col) => {
          data.addColumn(col.type, col.label)
        })

        this.chartData.forEach(function (row) {
          data.addRow(row)
        })

        this.$set(this, 'data', data)
        if (this.chartData.length > 0 || this.isAdmin === true) {
          this.loading = false
        }
      },
      onChartReady: function (chart, google) {
        this.chart = chart
        this.chartsLib = google

        // Blocco la chiamata alle api di google per evitare errori col font os-regular
        let head = document.getElementsByTagName('head')[0]
        let insertBefore = head.insertBefore
        head.insertBefore = function (newElement, referenceElement) {
          if (newElement.href && newElement.href.indexOf('//fonts.googleapis.com/css?family=os-regular') > -1) {
            return
          }
          insertBefore.call(head, newElement, referenceElement)
        }

        this.drawChart()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../assets/less/general.less";

  .column-chart {
    margin-bottom: 10px;
    .title {
      text-align: left;
      line-height: 35px;
      height: 35px;
      .set-font(@family: 'os-semibold', @size: 14px, @color: @greenRiva);
      letter-spacing: 2px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-left: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ServiceComponents/ColumnChart.vue